import classNames from 'classnames';
import throttle from 'lodash.throttle';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

const propTypes = exact({
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  contained: PropTypes.bool,
});

const defaultProps = {
  contained: false,
};

class StickyComponent extends Component {
  constructor(props) {
    super(props);

    this.fixedRef = React.createRef();
    this.inlineRef = React.createRef();

    this.handleScroll = this.handleScroll.bind(this);

    this.state = { isSticky: false };
  }

  componentDidMount() {
    this.handleScroll();
    this.scrollThrottle = throttle(this.handleScroll, 100);
    window.addEventListener('scroll', this.scrollThrottle, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollThrottle);
  }

  handleScroll() {
    if (this.inlineRef.current) {
      this.setState({ isSticky: this.inlineRef.current.getBoundingClientRect().bottom < 0 });
    }
  }

  render() {
    return (
      <>
        <div
          className={classNames('StickyComponent', {
            active: this.state.isSticky,
          })}
          ref={this.fixedRef}
        >
          {this.props.contained ? (
            <div className="StickyComponent_container">{this.props.children}</div>
          ) : (
            this.props.children
          )}
        </div>
        <div ref={this.inlineRef}>{this.props.children}</div>
      </>
    );
  }
}

StickyComponent.propTypes = propTypes;
StickyComponent.defaultProps = defaultProps;

export default StickyComponent;
